import "./displayProject.scss";
import Slider from "../../components/slider/Slider";
import Map from "../../components/map/Map";
import {  useNavigate,useLocation } from "react-router-dom";
import DOMPurify from "dompurify";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import apiRequest from "../../lib/apiRequest";
import { Helmet } from "react-helmet";
import { formatMonthYear, generatePostMessage } from "../../lib/allPurposeFunctions";
import { Image_profiles } from "../../lib/constants";



import pin from "../../assets/pin.png";
import noavatar from "../../assets/noavatar.png";
import size from "../../assets/size.png";
import bed from "../../assets/bed.png";
import bath from "../../assets/bath.png";
// import chat from "../../assets/chat.png";
import save from "../../assets/save.png";
import CommunicationItem from "../../components/communicationitem/CommunicationItem";
import { isLocalhost } from "../../../checkLocalhost";

import SharePostButton from "../../components/sharepost/SharePostButton";
import { BookmarkIcon, ChatIcon, DownloadIcon } from "../../lib/myIcons";
import BhoomiSlider from "../../components/basicslider/BhoomiSlider";
import CancelButton from "../../components/buttons/cancelbutton/CancelButton";

function DisplayProjectPage() {
//   const dataObj = useLoaderData();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext);
  const location=useLocation();



  const project = location.state?.project;

  const projectimagelocation = isLocalhost
    ? `${import.meta.env.VITE_PROJECTIMAGES_BASEURL}${project.id}`
    : `${import.meta.env.VITE_PROJECTIMAGES_SH_BASEURL}${project.id}`;

    const files = Array.isArray(project?.images) ? project.images : [];

// project.scannedMedia = files
//   .filter(file => file?.file_type !== "document")
//   .map(file => ({
//     image: file?.filename
//   }));


project.scannedMedia = (files || [])
  .filter(file =>
    file?.file_type !== "document" &&
    file?.file_type !== "video" &&
    file?.filename &&
    !file.filename.includes("http")
  )
  .map(file => ({
    image: file.filename,
    file_type: file.file_type
  }));


project.scannedDocuments = files
  .filter(file => file?.file_type === "document")
  .map(file => ({
    document: file?.filename
  }));


project.scannedusp=JSON.parse(project.usp || "[]")
project.scannedcommercials=JSON.parse(project.commercials || "[]")
  console.log("project",project )
  


const downloadFile = () => {
  const link = document.createElement("a");

  const projectimageslocation = isLocalhost
    ?import.meta.env.VITE_PROJECTIMAGES_BASEURL+project.id+"/"
    :import.meta.env.VITE_PROJECTIMAGES_SH_BASEURL+project.id+"/"


  link.href = projectimageslocation+project.scannedDocuments[0]?.document; // Assuming the first document is the brochure 
  link.download = project.projectname+"project.pdf"; // optional filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


// const downloadFile = async () => {
//   try {
//     const fileUrl = (isLocalhost
//       ? import.meta.env.VITE_PROJECTIMAGES_BASEURL
//       : import.meta.env.VITE_PROJECTIMAGES_SH_BASEURL) + project.id + "/" + project.scannedDocuments[0]?.document;

//     // Make API request for file content
//     const response = await apiRequest.get(fileUrl, { responseType: 'blob' });

//     const blob = response.data; // this is the file content

//     const link = document.createElement("a");
//     link.href = window.URL.createObjectURL(blob);
//     link.download = project.projectname + "_project.pdf"; // custom filename
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     window.URL.revokeObjectURL(link.href);

//   } catch (err) {
//     console.error("Download failed:", err);
//   }
// };

  if (!project) return <div>Loading project...</div>; // ✅ safe guard


  return (
    <>
    <div className="displayProjectPage">
      {/* <Helmet>
        <meta name="description" content={post.description} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.description} />

        <meta property="og:image" content={post?.avatarUrl} />

        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post.title} />
        <meta name="twitter:description" content={post.description} />

        <meta name="twitter:image" content={post?.avatarUrl} />

      </Helmet> */}

      <div className="projectContainer">
        <div className="projectRow projectcols">
          <div className="firstCol">
            <div className="ProjectImageswrapper">
                <Slider
                  images={project.scannedMedia}
                  // postid={project.id}
                  // userid={project.userid}
                  // builderpost={post.builderpost}
                  projectid={project.id}
                  ImageType={Image_profiles.PROJECT}                  
                />
                {console.log("latitude and longitude", project.latitude, project.longitude)}

                {(project.latitude !== '' || project.longitude !== '') && (
                  <div className="mapContainer">
                    
                    <Map items={[project]} />
                  </div>
                )}
              <div className="projectDescription">  
                  <div className="Descriptionwrapper">
                    <div className="info">
                      <div className="project">
                        <h1>{project.projectname}</h1>
                        <p className="transtype">
                          {project.heading}
                          {project.subheading}
                        </p>
                        <p>
                            <span>{project.residential_commercial=="R"?"Residential":"Commercial"}</span>
                            <span> Project:  </span>
                            <span>{project.completionstatus}, {formatMonthYear( project.completiondate)} </span>
                        </p>

                        <h4>{project.price_range}</h4>
                        <div className="address">
                          <img className="iconImage"  src={pin} alt="" />
                          <span>
                            {[
                              project.colonyname,
                              project.city,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </span>
                        </div>
                        {/* <div className="price">Rs. {post.price}</div> */}
                      </div>
                    </div>

                    
                    <div className="description">
                      <label className="title">Description</label>
                      <div>
                        {project.description}
                      </div>
                    </div>

                    <div className="generalTags">
                      <label className="title">USP Features</label>
                      <div>
                        {project?.scannedusp?.map((feature, index) => (
                          <span key={index} className="feature">
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="details">
                      <label className="title">Size Details</label>

                      <div>
                        {project?.scannedcommercials?.map((item) => (
                          <div key={item.id} className="size-item">
                            <p><strong>Beds:</strong> {item?.beds}</p>
                            <p><strong>Area:</strong> {item?.minarea} - {item?.maxarea} {item?.areaunit}</p>
                            <p><strong>Price:</strong> ₹{item?.minprice.toLocaleString()} - ₹{item?.maxprice.toLocaleString()}</p>
                            <p><strong>Type:</strong> {item?.propertytype}</p>
                            <hr />
                          </div>
                        ))}
                      </div>
                    </div>


                    <div className="projectDeveloper">
                      <div className="developerName">
                        <button
                          className="user"
                        >
                          {project?.builder?.buildername}
                        </button>

                      </div>


                      <div className="downloadBrochure">
                          <button
                            onClick={downloadFile}
                          >      
                            <DownloadIcon size={16} color="white"></DownloadIcon>
                            {project?.scannedDocuments?.length > 0 ? "Download Brochure" : "Brochure Not Available" }
                          </button>


                        </div>



                    </div>




                  </div>


              </div>
    
            </div>
    

          </div>

          <div className="secondCol">
            
              <div className="advertisementContainer">                
                  <BhoomiSlider></BhoomiSlider>
                              
              </div>


          </div>

        </div>


      </div>



        <div className="buttons">
          {/* <button
            onClick={handleSendMessage(post)}
          >
          <ChatIcon size={24} color="white"></ChatIcon>

            Send a Message
          </button> */}


            <button
          //   onClick={handleSave}
          >
            {/* <img className="iconImage" src={save} alt="" /> */}
            <BookmarkIcon size={24} color="white">

            </BookmarkIcon>

            {/* {hasSaved == "1" ? "Post Saved" : "Save the Post"} */}
          </button> 


          {/* <SharePostButton
            PostId={post.id}
            isLocalHost={isLocalhost}
            PostObject={post}
            
          ></SharePostButton> */}
          <CancelButton></CancelButton>



        </div>



    </div>
    
    </>

  );
}

export default DisplayProjectPage;
